import $ from 'jquery';

export default {

	init() {

		// Accordion menu
		$('.js-toggle-submenu').click(function(e) {
			e.preventDefault();

			// target the sub menu
			const parentItem = $(this).parent().parent('.menu-item-has-children');
			const childMenu = parentItem.children('.sub-menu');

			console.log(parentItem);
			console.log(childMenu);

			// update labels
			parentItem.attr("aria-expanded", !childMenu.is(':visible'));

			//update nav-walkers
			$(this).toggleClass("active");

			// open/close accordion
			childMenu.slideToggle(350);

		});

	}
};
